import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TagContext } from './Tag.context';
import { CloseButton, Container, Label } from './components';
/**
 * Tag component is used to display a label with an optional close button.
 */
export const Tag = (props) => {
    return (_jsx(TagContext.Provider, { value: props, children: _jsxs(Container, { children: [_jsx(Label, {}), _jsx(CloseButton, {})] }) }));
};
